import React from 'react';

const Manufacturing = () => {
  return (
    <div className="page-content">
      {/* OPTION 9: Image Grid Collage Header */}
      <section className="page-hero service-hero-grid" style={{
        position: 'relative',
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        marginTop: '120px',
        paddingTop: '3rem',
        paddingBottom: '3rem'
      }}>
        {/* Image Grid Background */}
        <div className="service-hero-grid-bg" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1rem',
          padding: '1rem',
          zIndex: 1
        }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{
              background: `linear-gradient(${135 + i * 20}deg, rgba(0, 104, 166, 0.6) 0%, rgba(171, 22, 54, 0.6) 100%)`,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span className="material-icons" style={{fontSize: '3rem', color: 'rgba(255, 255, 255, 0.3)'}}>
                {['precision_manufacturing', 'factory', 'engineering', 'content_cut', 'water_drop', 'air', 'build_circle', 'settings'][i]}
              </span>
            </div>
          ))}
        </div>
        
        {/* Dark Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          zIndex: 2
        }}></div>
        
        <div className="container" style={{position: 'relative', zIndex: 3, textAlign: 'center', padding: '4rem 20px'}}>
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            <div className="service-badge" style={{
              display: 'inline-block',
              fontSize: '0.9rem',
              fontWeight: '600',
              color: 'var(--white)',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              paddingBottom: '0.5rem',
              borderBottom: '3px solid var(--accent-blue)',
              marginBottom: '2rem'
            }}>
              Professional Services
            </div>
            
            <h1 className="service-title" style={{
              color: 'var(--white)',
              fontSize: '4.5rem',
              fontWeight: '700',
              marginBottom: '1.5rem',
              lineHeight: '1.1'
            }}>
              Manufacturing
            </h1>
            
            <p className="service-subtitle" style={{
              color: 'rgba(255, 255, 255, 0.95)',
              fontSize: '1.5rem',
              lineHeight: '1.6',
              marginBottom: '0'
            }}>
              State-of-the-art fabrication facilities producing high-quality mechanical components and systems
            </p>
          </div>
        </div>
      </section>

      {/* Section 1: Manufacturing Facility */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Manufacturing Excellence</h2>
            <p>State-of-the-art facilities for comprehensive mechanical component production</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                Bel-Aire Mechanical has made a substantial commitment to the manufacturing of the piping, plumbing and sheet metal components for all our projects and for other mechanical contractors and clients.
              </p>
              
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)'}}>
                Our principal expanded pipe, plumbing and sheet metal manufacturing facilities are all state-of-the-art. The entire <strong style={{color: 'var(--accent-blue)'}}>5+ acre complex encompasses a 42,000 square foot high bay facility</strong> that houses 16,000 square feet of offices, support space and dedicated manufacturing areas with room for future growth.
              </p>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Manufacturing Facility Image]
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto'}}>
            <div style={{background: 'var(--secondary-light)', padding: '2.5rem', borderRadius: '10px', marginBottom: '2rem'}}>
              <div style={{textAlign: 'center', marginBottom: '2rem'}}>
                <div style={{display: 'inline-block', background: 'var(--accent-blue)', color: 'var(--white)', padding: '1.5rem 3rem', borderRadius: '50px', boxShadow: '0 6px 25px rgba(0, 104, 166, 0.3)'}}>
                  <p style={{fontSize: '2.5rem', fontWeight: '700', margin: '0 0 0.5rem 0'}}>42,000</p>
                  <p style={{fontSize: '1rem', margin: 0, textTransform: 'uppercase', letterSpacing: '1px'}}>Square Feet Manufacturing Facility</p>
                </div>
              </div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: 0, textAlign: 'center'}}>
                Complete manufacturing capabilities under one roof with dedicated areas for pipe fabrication, sheet metal production, and assembly operations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Reduce Project Cost */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Reduce Project Cost</h2>
            <p>Integrated manufacturing approach for maximum efficiency and cost savings</p>
          </div>
          
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center'}} className="precon-grid-2col">
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Manufacturing Process Image]
            </div>
            
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                This manufacturing philosophy plays well into our <strong style={{color: 'var(--accent-blue)'}}>Integrated Project Delivery (IPD), LEAN and Last Planner approach</strong>. This modular manufacturing mentality reduces the total manpower required to complete any project, provides more access for other trades and contributes to the overall substantial cost savings in labor and material through strict monitoring of productivity and material waste.
              </p>
              
              <div style={{background: 'var(--accent-blue)', color: 'var(--white)', padding: '2rem', borderRadius: '10px'}}>
                <h3 style={{color: 'var(--white)', fontSize: '1.3rem', marginBottom: '1rem'}}>Manufacturing Benefits</h3>
                <p style={{fontSize: '1.05rem', lineHeight: '1.7', color: 'rgba(255, 255, 255, 0.95)', margin: 0}}>
                  Our integrated manufacturing approach delivers reduced manpower requirements, improved trade coordination, and substantial cost savings through enhanced productivity and waste reduction.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Computer Aided Design and Manufacturing */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Computer Aided Design and Manufacturing</h2>
            <p>Advanced CAD/CAM integration with BIM for precision manufacturing</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                Bel-Aire Mechanical uses <strong style={{color: 'var(--accent-blue)'}}>CAD and CAM software in both our Pipe and Sheet Metal manufacturing</strong>. The Design and Manufacturing software integrates with our BIM software to manufacture pipe spools and hvac duct to specification and with minimum waste.
              </p>
              
              <div style={{background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', color: 'var(--white)', padding: '2.5rem', borderRadius: '10px', boxShadow: '0 6px 25px rgba(171, 22, 54, 0.3)'}}>
                <h3 style={{color: 'var(--white)', fontSize: '1.3rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem'}}>
                  <span className="material-icons" style={{fontSize: '1.5rem'}}>precision_manufacturing</span>
                  CAD/CAM Integration
                </h3>
                <p style={{fontSize: '1.05rem', lineHeight: '1.8', color: 'rgba(255, 255, 255, 0.95)', margin: 0}}>
                  Seamless integration between our design, manufacturing, and BIM software ensures precise fabrication with minimal waste and maximum efficiency. Data flows directly from our BIM modeling stations to our manufacturing equipment.
                </p>
              </div>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [CAD/CAM Workstation Image]
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: Just-In-Time Delivery */}
      <section className="section" style={{background: 'var(--secondary-light)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Just-In-Time Delivery</h2>
            <p>Strategic off-site storage and logistics for optimal project coordination</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Storage and Logistics Image]
            </div>
            
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                We also will provide <strong style={{color: 'var(--accent-blue)'}}>off site logistical storage of manufactured systems</strong> minimizing project footprint, and facilitating "Just in Time" deliveries to the jobsite. Bel-Aire Mechanical's manufacturing facility, laydown and storage areas are less than 9 miles from the jobsite.
              </p>
              
              <div style={{background: 'var(--white)', padding: '2.5rem', borderRadius: '10px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)', border: '2px solid var(--accent2-red)'}}>
                <h3 style={{fontSize: '1.5rem', marginBottom: '1.5rem', color: 'var(--accent2-red)'}}>Strategic Location Advantage</h3>
                <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', margin: 0}}>
                  Our manufacturing facility and storage areas are strategically located less than 9 miles from job sites, enabling efficient just-in-time delivery while minimizing project site congestion and maximizing available workspace for other trades.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 5: Manufacturing Highlights */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 50%, rgba(0, 104, 166, 0.1) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Bel-Aire Manufacturing Highlights</h2>
            <p>State-of-the-art equipment and advanced manufacturing capabilities</p>
          </div>
          
          <div style={{maxWidth: '1200px', margin: '0 auto'}}>
            <div className="manufacturing-highlights-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(3, 1fr)', 
              gap: '1.5rem'
            }}>
              <div className="manufacturing-highlight-card manufacturing-card-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>precision_manufacturing</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Plasma Cutting Technology</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Fully programmable plasma table</li>
                  <li>Capable of cutting bevels, saddles, shapes and miters</li>
                  <li>Fully programmable utilizing plasma and fuel gas</li>
                  <li>Data directly download from BIM modeling stations</li>
                </ul>
              </div>
              
              <div className="manufacturing-highlight-card manufacturing-card-red" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>build</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Sheet Metal Capabilities</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>90 ton press brake</li>
                  <li>Multiple 5000lb coil line</li>
                  <li>Galvanized to 10 ga</li>
                  <li>Mild steel to 1/4"</li>
                  <li>Stainless steel to 3/16"</li>
                </ul>
              </div>
              
              <div className="manufacturing-highlight-card manufacturing-card-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>settings</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Advanced Welding Technology</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>ASME certified pipe welders</li>
                  <li>Latest computer controlled welding techniques</li>
                  <li>Manipulator/Oscillator technology</li>
                  <li>High degree of repeatability and accuracy</li>
                </ul>
              </div>
              
              <div className="manufacturing-highlight-card manufacturing-card-red" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>plumbing</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Pipe Manufacturing</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Manufacturing pipe sizes from 3" to 36"</li>
                  <li>Multiple axis computer controlled pipe cutter</li>
                  <li>Regulated Metal Deposition welding</li>
                  <li>Pro Pulse welding programs</li>
                </ul>
              </div>
              
              <div className="manufacturing-highlight-card manufacturing-card-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>verified</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Quality & Efficiency</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>X-ray quality welding at 40% cost reduction</li>
                  <li>Increased productivity using advanced programs</li>
                  <li>Computer controlled precision cutting</li>
                  <li>Minimum waste manufacturing processes</li>
                </ul>
              </div>
              
              <div className="manufacturing-highlight-card manufacturing-card-red" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>integration_instructions</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>BIM Integration</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Direct data download from BIM stations</li>
                  <li>CAD/CAM software integration</li>
                  <li>Manufacture to specification</li>
                  <li>Seamless design-to-fabrication workflow</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      
    </div>
  );
};

export default Manufacturing;
